import { FC, PropsWithChildren } from 'react';

import { PermissionType } from 'api/types/entity';
import { ContentHeader } from 'components';
import { NavigationLink } from 'components/NavigationLink';
import { useTranslation } from 'libs/i18n';
import { ROUTES } from 'libs/navigation';
import { usePermissions } from 'libs/permissions';
import { Stack, Tab, Tabs } from 'libs/ui';

export interface AdministrationViewProps extends PropsWithChildren {
  headerRightContent?: React.ReactNode;
  tabValue: 'onboarding' | 'accountingSystem' | 'admins';
}

const LinkComponent = ({
  children,
  href,
  className,
}: { href: string; className?: string } & PropsWithChildren) => (
  <NavigationLink className={className} to={href}>
    {children}
  </NavigationLink>
);

export const AdministrationView: FC<AdministrationViewProps> = ({
  headerRightContent,
  children,
  tabValue,
}) => {
  const { t } = useTranslation();

  const { checkPermissions } = usePermissions();

  return (
    <>
      <Stack spacing={24}>
        <ContentHeader
          header={t('administration.title')}
          rightContent={headerRightContent}
        />
        <Tabs value={tabValue}>
          {checkPermissions([PermissionType.SystemSetting_GetOne]) && (
            <Tab
              href={ROUTES.administration.accountingSystem.fullPath}
              label={t('administration.accountingSystem.title')}
              LinkComponent={LinkComponent}
              value="accountingSystem"
            />
          )}
          {checkPermissions([PermissionType.SystemSetting_GetOne]) && (
            <Tab
              href={ROUTES.administration.onboardingSettings.fullPath}
              label={t('administration.onboarding.title')}
              LinkComponent={LinkComponent}
              value="onboarding"
            />
          )}
          {checkPermissions([PermissionType.User_GetList]) && (
            <Tab
              href={ROUTES.administration.admins.fullPath}
              label={t('administration.admins.title')}
              LinkComponent={LinkComponent}
              value="admins"
            />
          )}
        </Tabs>
      </Stack>
      {children}
    </>
  );
};
